export default __webpack_public_path__ + "static/media/pristavka.d8c6aaaf.webp";